import React from "react";
import Accordion from "../../atoms/accordion/accordion";
import {IconSource} from "../../../shared/enums/iconSource";

export interface IAccordionGroupProps {
  accordions: {
    header: (isExpended: boolean) => React.ReactNode;
    id: string;
    children: React.ReactNode;
    toggleIcon?: IconSource;
    toggleIconColor?: "primary" | "secondary";
    isExpanded: boolean;
    onAccordionClick: (id: string, isExpanded: boolean) => void;
    hideToggleIcon?: boolean;
  }[];
}

const AccordionGroup: React.FC<IAccordionGroupProps> = ({accordions}) => {
  return (
    <div className="accordion-group">
      {accordions.map(
        ({
          id,
          header,
          children,
          toggleIcon,
          toggleIconColor,
          isExpanded,
          onAccordionClick,
          hideToggleIcon
        }) => (
          <Accordion
            key={id}
            isExpanded={isExpanded}
            header={header}
            id={id}
            setIsExpanded={(id: string, isExpanded: boolean) =>
              onAccordionClick(id, isExpanded)
            }
            toggleIcon={toggleIcon}
            toggleIconColor={toggleIconColor}
            hideToggleIcon={hideToggleIcon}
          >
            {children}
          </Accordion>
        )
      )}
    </div>
  );
};

export default AccordionGroup;
